<script lang="ts">
  import MainLayout from "../#common/layout/Layout.svelte"
  import {Link} from 'svelte-routing'
  import IconifyIcon from '@iconify/svelte'
  import moreIcon from '@iconify/icons-fa-solid/chevron-right'
</script>

<svelte:head>
  <title>Analytics</title>
</svelte:head>

<MainLayout title="Analytics">
  <svelte:fragment slot="content">
      <div class="row">
        <div class="col-xl-4 col-xxl-3">
          <Link to="/analytics/merge" class="card card-body analytics-card">
              <div class="name">Merge Games</div>
              <div class="config-card-details">Details <IconifyIcon icon={moreIcon}></IconifyIcon></div>
          </Link>
        </div>
        <div class="col-xl-4 col-xxl-3">
          <Link to="/analytics/swap" class="card card-body analytics-card">
              <div class="name">Swap</div>
              <div class="config-card-details">Details <IconifyIcon icon={moreIcon}></IconifyIcon></div>
          </Link>
        </div>
        <div class="col-xl-4 col-xxl-3">
          <Link to="/analytics/wallet" class="card card-body analytics-card">
              <div class="name">Wallet</div>
              <div class="config-card-details">Details <IconifyIcon icon={moreIcon}></IconifyIcon></div>
          </Link>
        </div>
        <div class="col-xl-4 col-xxl-3">
          <Link to="/analytics/activity" class="card card-body analytics-card">
              <div class="name">Activity</div>
              <div class="config-card-details">Details <IconifyIcon icon={moreIcon}></IconifyIcon></div>
          </Link>
        </div>
      </div>
  </svelte:fragment>
</MainLayout>

<style>
  .name {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    font-size: 20px;
    color: #6c757d;
    font-weight: 500;
  }

  .config-card-details {
    border-top: 1px solid #d9d9d9;
    text-align: right;
    padding-top: 15px;
    margin-top: 16px;
    color: #6c757d;
    transition: .25s;
  }

  .config-card-details :global(svg) {
    vertical-align: top;
    margin: 4px 0 0 5px;
    color: #8d9297;
  }

  :global(.analytics:hover) .config-card-details {
    color: #ff5d1c;
  }

  .card:hover {
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15), 0 2px 7px #e1e3eb;
  }

  @media(max-width: 767px) {
    .name,
    .create {
        height: 80px;
    }
  }

  :global(.analytics-pane p.description) {
    font-size: 14px;
    font-style: italic;
  }
  
  :global(.analytics-pane .buttons) {
    margin-bottom: 15px;
  }

  :global(.analytics-pane .buttons .btn) {
    margin-left: 5px;
  }

  :global(.analytics-pane .btn-primary.btn-filter) {
    padding: 8px 20px;
  }

  :global(.analytics-pane .form-select), :global(.analytics-pane .form-control) {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  :global(.analytics-pane input[type="date"]) {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  :global(.analytics-pane .date-label) {
    padding: 0 5px;
    line-height: 38px;
    font-weight: 500;
  }

  :global(.analytics-pane .pc-line) {
    display: inline-block;
    margin-bottom: 10px;
  }

  :global(.analytics-pane .graphic) {
    position: relative;
    min-height: 160px;
  }

  :global(.analytics-pane .graphic-loading) {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
  }

  @media(max-width: 767px) {
    :global(.analytics-pane .pc-line) {
      display: block;
    }

    :global(.analytics-pane .pc-line .btn) {
      margin-left: 0;
      width: 100%;
    }

    :global(.analytics-pane .date-label) {
      font-size: 14px;
    }

    :global(.analytics-pane .btn-filter) {
      margin-bottom: 10px;
    }
  }
</style>